import { render, staticRenderFns } from "./HomeNavigationDrawerFooter.vue?vue&type=template&id=4505a064&scoped=true&"
import script from "./HomeNavigationDrawerFooter.vue?vue&type=script&lang=js&"
export * from "./HomeNavigationDrawerFooter.vue?vue&type=script&lang=js&"
import style0 from "./HomeNavigationDrawerFooter.vue?vue&type=style&index=0&id=4505a064&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4505a064",
  null
  
)

export default component.exports